import { useEffect, useRef } from 'react';

import { oidcService } from '../../services/oidcService';
import {
  setAuthenticated,
  setRestoring,
  setUnauthenticated,
  setWorkspaceAuthenticated,
  setWorkspaceSelecting,
} from '../slices/authSlice';
import { getWorkspaceContext } from '../utils/inMemoryTokenStore';

import { useAppDispatch } from '@store/hooks';

const AuthSessionRestorer: React.FC = () => {
  const dispatch = useAppDispatch();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const restore = async () => {
      dispatch(setRestoring());

      try {
        const session = await oidcService.restoreSession();

        if (!session) {
          dispatch(setUnauthenticated());
          return;
        }

        const ctx = getWorkspaceContext();

        if (ctx && ctx.tenantName) {
          // Context is fully populated — proceed directly to authenticated.
          dispatch(setAuthenticated(session));
          dispatch(setWorkspaceAuthenticated(ctx));
        } else if (ctx) {
          // Context exists but display names are missing (corrupted preference
          // from an earlier bug). Route through workspace selector so names
          // are restored from the live memberships API.
          dispatch(setWorkspaceSelecting(session));
        } else {
          dispatch(setWorkspaceSelecting(session));
        }
      } catch {
        dispatch(setUnauthenticated());
      }
    };

    void restore();
  }, [dispatch]);

  return null;
};

export default AuthSessionRestorer;
